import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { PodcastSource } from "@/types/podcast";
import { useNavigate } from "@/lib/router-compat";
import SmartImage from "@/components/ui/SmartImage";

interface PodcastCardProps {
  podcast: PodcastSource;
}

const PodcastCard = ({ podcast }: PodcastCardProps) => {
  const navigate = useNavigate();

  return (
    <Card
      className="group cursor-pointer overflow-hidden hover:shadow-lg transition-all duration-300"
      onClick={() => navigate(`/podcasts/${podcast.id}`)}
    >
      <div className="aspect-square relative overflow-hidden bg-muted">
        {podcast.image_url ? (
          <SmartImage
            src={podcast.image_url}
            alt={podcast.name}
            w={320}
            h={320}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-4xl">
            🎙️
          </div>
        )}
        {podcast.episode_count !== undefined && (
          <Badge className="absolute top-2 right-2">
            {podcast.episode_count} episodes
          </Badge>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-semibold text-lg mb-1 line-clamp-2 group-hover:text-primary transition-colors">
          {podcast.name}
        </h3>
        {podcast.author && (
          <p className="text-sm text-muted-foreground mb-2">{podcast.author}</p>
        )}
        {podcast.description && (
          <p className="text-sm text-muted-foreground line-clamp-2">
            {podcast.description}
          </p>
        )}
      </div>
    </Card>
  );
};

export default PodcastCard;
